import React from 'react'

const Email = () => {
  return (
    <div>
      Account
    </div>
  )
}

export default Email
